module.exports = __webpack_public_path__ + "img/Reacondicionamiento.a99fd052.png";